<div class="birthdays">
  <div class="birthdays__header">
    <app-header [options]="headerOptions"></app-header>
  </div>

  <div class="birthdays__list">
    <div class="search">
      <tui-input-date-range tuiTextfieldSize="s" [formControl]="periodControl">
        {{ 'components.birthdaysList.fields.period' | translate }}
      </tui-input-date-range>

      <app-banner
        *ngxPermissionsOnly="['birthdaysNotificationsBannerViewing']"
        [link]="'/settings/notifications'"
        [icon]="'bell-ring'"
        [title]="'components.birthdaysList.labels.notificationsBannerTitle' | translate"
        [description]="'components.birthdaysList.labels.notificationsBannerDescription' | translate"
      ></app-banner>
    </div>

    <tui-scrollbar>
      <app-new-list
        [items]="items$ | async"
        [(selectedId)]="selectedId"
        (selectedIdChange)="onChangeSelectedId($event)"
        [itemContentTmp]="listItemTmp"
      ></app-new-list>
    </tui-scrollbar>
  </div>
</div>

<ng-template #listItemTmp let-item>
  <new-list-item-birthdays-user [user]="item" [birthDateContent]="tagTmp"></new-list-item-birthdays-user>
</ng-template>

<ng-template #tagTmp let-value>
  <birthdays-tag [value]="value"></birthdays-tag>
</ng-template>
